/**
 * Trigramm-Ähnlichkeit, nachgebaut nach PostgreSQL `pg_trgm`.
 *
 * Der Server rechnet mit `similarity()` aus der Datenbank, das Gerät kann
 * das offline nicht. Damit dieselbe Eingabe hier und dort dieselben
 * Kandidaten in derselben Reihenfolge ergibt, wird das Verfahren exakt
 * nachgebildet, und ein Test in der API vergleicht beide Fassungen an
 * echten Namen gegen die laufende Datenbank.
 *
 * Verfahren laut pg_trgm: jedes Wort wird mit zwei führenden und einem
 * abschliessenden Leerzeichen umgeben, daraus alle Dreiergruppen gebildet;
 * die Ähnlichkeit ist der Jaccard-Koeffizient der Trigramm-Mengen.
 */
export function trigrams(input) {
    const result = new Set();
    const words = (input ?? '').toLowerCase().split(/[^a-z0-9]+/i).filter(Boolean);
    for (const word of words) {
        const padded = `  ${word} `;
        for (let i = 0; i + 3 <= padded.length; i++)
            result.add(padded.slice(i, i + 3));
    }
    return result;
}
export function similarity(a, b) {
    const left = trigrams(a);
    const right = trigrams(b);
    if (left.size === 0 && right.size === 0)
        return 0;
    let shared = 0;
    for (const t of left)
        if (right.has(t))
            shared++;
    const union = left.size + right.size - shared;
    return union === 0 ? 0 : shared / union;
}
/** Voreinstellung von pg_trgm für den `%`-Operator. */
export const SIMILARITY_THRESHOLD = 0.3;
